exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js!../../../node_modules/vue-plyr/dist/vue-plyr.css"), "");
exports.i(require("-!../../../node_modules/css-loader/index.js!../../../node_modules/normalize.css/normalize.css"), "");

// module
exports.push([module.id, "body{padding:0}header{position:fixed;top:7%;left:0;width:100%;z-index:9}.container{width:100vw;height:100vh;overflow:hidden}.wrapper{height:100%}.page-contact{position:relative}.VideoBg{width:100%;position:absolute}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/assets/scss/app.scss
// module id = 69
// module chunks = 0